import { defineStore } from 'pinia'

import { createReportExecutionActions } from './actions'
import { createReportExecutionState } from './state'

export const useReportExecutionV2Store = defineStore('reportsV2ReportExecution', () => {
    const state = createReportExecutionState()
    const actions = createReportExecutionActions(state)

    return {
        ...state,
        ...actions
    }
})
